/**
 * Shared types for Brand Editor (spec 0020).
 */
import type { BrandTemplate } from '@/api/types';

export interface EditorState {
  productId: number | '';
  slug: string;
  displayName: string;
  // Spec 0015 — editable image key/base pairs
  logoImage: string;
  logoBaseUrl: string;
  faviconImage: string;
  faviconBaseUrl: string;
  heroImage: string;
  heroBaseUrl: string;
  colors: Record<string, string>;
  fonts: Record<string, string>;
  copyEntries: Array<{ key: string; value: string }>;
  authProviders: string[];
  signupEnabled: boolean;
  passwordResetEnabled: boolean;
  // Spec 0016 — top-level login-template + marketing fields
  template: BrandTemplate | '';
  shortName: string;
  tagline: string;
  heroCopy: string;
  location: string;
  // Spec 0030 — single on/off toggle (URL + label moved to the product)
  guestSignupEnabled: boolean;
  primaryColorHover: string;
  // Spec 0018 Part C — login_title promoted from copyStrings
  loginTitle: string;
  // SASADM-0155 — copyStrings.welcomeHeadline, edited like loginTitle
  welcomeHeadline: string;
}

// SASADM-0074 — the auth-methods a brand may allow, rendered as checkboxes in the
// Brand editor. 'microsoft' added once the backend accepts it (SASATH-0109). Shared
// by BrandEditor (Advanced tab) and BrandEditorTabs (Preview slot popover) so the two
// lists cannot drift.
export const SUPPORTED_PROVIDERS = ['password', 'google', 'microsoft'] as const;
